import React from 'react';
import { animated, useSpring } from 'react-spring';

function countZerosAfterDecimal(numberStr: string): number {
  // Split the string at the decimal point
  let parts = numberStr.split(".");
  
  // Check if there is a fractional part
  if (parts.length < 2) {
    return 0; // No decimal point means no zeros after decimal
  }

  let fractionalPart = parts[1];

  // Initialize a counter for zeros
  let zeroCount = 0;

  // Loop through the fractional part and count zeros until a non-zero digit is found
  for (let i = 0; i < fractionalPart.length; i++) {
    if (fractionalPart[i] === '0') {
      zeroCount++;
    } else {
      break; // Stop counting once the first non-zero digit is found
    }
  }

  return zeroCount;
}

type Props = {
  value: number | undefined | null;
  displayDecimals?: number;
  removeTrailingZeros?: boolean;
  defaultDisplay?: string;
  postfix?: string;
  prefix?: string;
  isLoading?: boolean;
  id?: string;
  abbreviate?: boolean;
};

// https://github.com/buildo/react-placeholder
// https://skeletonreact.com/
const FormatNumber: React.FC<Props> = (props) => {
  const [showLoader, setShowLoader] = React.useState(false);

  React.useEffect(() => {
    if (props.isLoading) {
      setShowLoader(true);
    }

    // Show loader a bits longer to avoid loading flash
    if (!props.isLoading && showLoader) {
      setShowLoader(false);
    }
  }, [props.isLoading, showLoader]);

  // Hooks used to fade in/out the loader or the button contents
  const fadeOutProps = useSpring({ opacity: showLoader ? 1 : 0 });
  const fadeInProps = useSpring({ opacity: showLoader ? 0 : 1 });

  const prefix = props.prefix || '';
  const postfix = props.postfix || '';
  if (props.isLoading) {
    return (
      <div className="loadable-small">
        <animated.div style={fadeOutProps}>
          <div className="loader" />
        </animated.div>
      </div>
    );
  }

  let decimals = props.displayDecimals !== undefined ? props.displayDecimals : 2;
  let abbrLetter = '';
  let value = props.value;
  if (props.abbreviate && value) {
    if (value > 10**12) {
      value = value/(10**12);
      abbrLetter = 't';
    }
    if (value > 10**9) {
      value = value/(10**9);
      abbrLetter = 'b';
    }
    if (value > 10**6) {
      value = value/(10**6);
      abbrLetter = 'm';
    }
    if (value > 10**3) {
      value = value/(10**3);
      abbrLetter = 'k';
    }
  }
  // if (value?.toString().includes('.')){
  //   decimals = countZerosAfterDecimal(value?.toString()) + 2;
  // }
  // if (value && value > 100) {
  //   decimals = 1;
  // }
  // if (value && value > 1000) {
  //   decimals = 0;
  // }

  if (value !== null) {
    // let numValue = decimals > 0 ? value?.toFixed(decimals).replace(/\.?0+$/g, '') : value?.toFixed(decimals);
    let numValue = value?.toFixed(decimals);
    return (
      <animated.div style={fadeInProps} id={props.id}>
        {prefix}
        {/* replace() removes trailing zeros */}
        <span className="cy-number-percent">{numValue}</span>
        {abbrLetter}
        {postfix}
      </animated.div>
    );
  }

  if (props.defaultDisplay) {
    return (
      <animated.div style={fadeInProps}>
        {prefix}
        {props.defaultDisplay}
        {postfix}
      </animated.div>
    );
  }
  return null;
};

export default FormatNumber;
